<template>
  <div class="periodicalDetails">
    <div class="d-main tabNav">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/periodical' }"
          >期刊出版</el-breadcrumb-item
        >
        <el-breadcrumb-item>期刊详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bookBox d-main">
      <el-image :src="newDetails.cover" fit="fill"></el-image>
      <div class="boxItemMain">
        <div class="boxItemMain-title">{{ newDetails.name }}</div>
        <div class="boxItemMain-text">作者：{{ newDetails.writer }}</div>
        <div class="boxItemMain-text">页数：{{ newDetails.page }}</div>
        <div class="boxItemMain-text">
          价格：
          <span>￥{{ newDetails.price }}</span>
        </div>
        <div
          class="boxItemMain-button"
          @click.stop="showDadilog(newDetails.id)"
        >
          购买咨询
        </div>
      </div>
    </div>
    <div class="d-main" v-html="newDetails.content"></div>
    <div class="he50"></div>
    <div class="he50"></div>
    <periodicalDadilog
      v-if="dadilogType"
      :shopid="shopid"
      @hide="hidedadilog"
    />
  </div>
</template>

<script>
import periodicalDadilog from "@/components/pc/periodical/dadilog.vue";
import { getPeriodicalDetail } from "@/api/api.js";

export default {
  name: "PcPeriodicalDetails",
  data() {
    return {
      shopid: "",
      dadilogType: false,
      newDetails: {
        content: "",
        cover: "",
        createTime: "",
        file: "",
        id: "",
        introduction: "",
        isMember: "",
        isRecommend: "",
        isShow: "",
        lastUpdateTime: "",
        name: "海之思",
        page: "",
        price: "",
        writer: ""
      }
    };
  },
  components: {
    periodicalDadilog
  },
  mounted() {
    this.getData(this.$route.query.id);
  },
  methods: {
    getData(val) {
      if (val) {
        this.title = val;
        this.getPeriodicalDetail(val);
      } else {
        this.$router.push({ name: "pcperiodical" });
      }
    },
    hidedadilog() {
      this.dadilogType = false;
    },
    getPeriodicalDetail(val) {
      getPeriodicalDetail(val).then(res => {
        if (res.code === 0) {
          this.newDetails = {
            content: res.data.content,
            cover: res.data.cover,
            createTime: res.data.createTime,
            file: res.data.file,
            id: res.data.id,
            introduction: res.data.introduction,
            isMember: res.data.isMember,
            isRecommend: res.data.isRecommend,
            isShow: res.data.isShow,
            lastUpdateTime: res.data.lastUpdateTime,
            name: res.data.name,
            page: res.data.page,
            price: res.data.price,
            writer: res.data.writer
          };
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    showDadilog(id) {
      this.shopid = id;
      this.dadilogType = true;
    }
  }
};
</script>

<style lang="less">
.periodicalDetails {
  .tabNav {
    margin: 70px auto 40px;
  }
  .bookBox {
    display: flex;
    margin-bottom: 40px;
    height: 270px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 1px 6px 20px 0px rgba(146, 146, 146, 0.16);
    .el-image {
      width: 202px;
      height: 270px;
    }
    .boxItemMain {
      width: calc(100% - 202px);
      height: 270px;
      padding: 16px;
      box-sizing: border-box;
      &-title {
        font-size: 22px;
        font-weight: bold;
        color: rgba(52, 52, 52, 1);
      }
      &-text {
        margin: 10px 0;
        font-size: 16px;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        span {
          font-size: 16px;
          font-weight: 400;
          color: rgba(255, 26, 26, 1);
        }
      }
      &-button {
        margin-top: 50px;
        width: 126px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        background: rgba(108, 44, 102, 1);
        cursor: pointer;
      }
    }
  }
  .bookBoxtitle {
    margin-top: 30px;
    font-size: 26px;
    font-weight: bold;
    color: rgba(52, 52, 52, 1);
  }
  .bookBoxtext {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(52, 52, 52, 1);
    line-height: 24px;
  }
}
</style>
